<template>
  <action-dispatcher
    action="courses/getDetails"
    :parameters="$route.params.id"
    ref="coursesDispatcher"
    class="view-lesson pt-5"
    @success="onSuccess"
  >
    <div v-if="lesson" class="container-fluid px-lg-5 py-5 order-lg-1">
      <div class="d-flex">
        <router-link
          class="text-decoration-none text-light"
          :to="{ name: 'course', params: { ...course } }"
        >
          <h6 class="text-light mb-4">
            <i class="icon-chevron-left"></i> {{ course.title }}
          </h6>
        </router-link>
      </div>

      <div class="row">
        <div class="order-lg-1 col-lg-7 col-xl-8">
          <!--Audio Player-->
          <audio-player
            v-if="isAudio(lesson)"
            :lesson="lesson"
            @save-progress="saveProgress"
          />
          <video-player
            v-else-if="!isVideoIframe(lesson.stream_url) && lesson.stream_url"
            ref="video-player"
            :lesson="lesson"
            @save-progress="saveProgress"
          />
          <!-- iframe youtube -->
          <iframe
            v-else-if="isVideoIframe(lesson.stream_url)"
            :src="lesson.stream_url"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <!-- /iframe youtube -->
          <iframe class="mb-4" v-else-if="archive" :src="archive"></iframe>
        </div>

        <div class="order-lg-3 col-lg-7 col-xl-8">
          <div
            class="buttons d-flex flex-column flex-md-row justify-content-between align-items-center my-3"
          >
            <button
              class="btn btn-sm btn-outline px-3 d-flex align-items-center"
              @click="toggleFinished"
            >
              <b-spinner v-if="loadingFinish" small />
              <span class="d-flex" v-else>
                <i v-if="finishedLesson" class="icon-check-circle mr-2"></i>
                <i v-if="!finishedLesson" class="icon-circle mr-2"></i>
                <span v-if="finishedLesson">Aula finalizada</span>
                <span v-else>Marcar como finalizada</span>
              </span>
            </button>

            <div class="flex-fill"></div>

            <router-link
              v-if="nextLesson"
              class="btn btn-sm btn-primary px-3 d-flex align-items-center"
              :to="{ name: 'lesson', params: { lesson: nextLesson.id } }"
            >
              Próxima aula
            </router-link>
          </div>
          <div class="mt-5">
            <h4 class="font-weight-bold mb-2">{{ lesson.name }}</h4>
            <div class="lesson-description" v-html="lesson.description"></div>
          </div>

          <div v-if="lesson.archives.length > 0 && !isAudio(lesson)">
            <h5>Materiais complementares</h5>
            <div v-for="(archive, index) in lesson.archives" :key="index">
              <a :href="archive.file" target="_blank" class="py-2">
                {{ fileName(archive) }}
              </a>
            </div>
          </div>

          <h5 class="my-4 py-2">{{ count }} Comentários</h5>

          <send-comment :lesson="$route.params.lesson" @success="reload" />

          <action-dispatcher
            action="forum/getAll"
            :parameters="params"
            ref="forumDispatcher"
          >
            <div v-for="comment in comments" :key="'c' + comment.id">
              <comment class="mt-4" :comment="comment" @success="reload" />
            </div>
          </action-dispatcher>

          <div class="text-center pt-4" v-if="comments.length">
            <button
              v-if="showLoadMore"
              class="btn btn-outline px-5 font-weight-bold"
              @click="loadMore"
            >
              <loading :show="loadingMore">Carregar mais</loading>
            </button>
          </div>
        </div>

        <div class="order-lg-2 col-lg-5 col-xl-4">
          <div class="scroll-desktop">
            <lessons-list :course="course" />
          </div>
        </div>
      </div>
    </div>
  </action-dispatcher>
</template>

<script>
import LessonsList from "../components/lesson/LessonsList";
import VideoPlayer from "../components/lesson/VideoPlayer";
import SendComment from "../components/lesson/SendComment";
import Comment from "../components/lesson/Comment";
import { mapState } from "vuex";
import get from "lodash/get";
import AudioPlayer from "../components/lesson/AudioPlayer.vue";

export default {
  components: {
    LessonsList,
    VideoPlayer,
    SendComment,
    Comment,
    AudioPlayer
  },
  data() {
    return {
      loadingFinish: false,
      tab: "chapters",
      params: {
        id: this.$route.params.lesson,
        limit: 10,
        offset: 0
      },
      loadingMore: false,
      showLoadMore: true
    };
  },
  computed: {
    ...mapState("courses", ["course"]),
    ...mapState("forum", ["comments", "count"]),
    archive() {
      return get(this.lesson, "archives[0].file");
    },
    lesson() {
      if (!this.course.lessons) {
        return null;
      }
      return this.course.lessons.find(
        lesson => lesson.id === parseInt(this.$route.params.lesson)
      );
    },
    nextLesson() {
      for (let i = 0; i < this.course.lessons.length; i++) {
        if (this.course.lessons[i].id === parseInt(this.$route.params.lesson)) {
          return this.course.lessons[i + 1];
        }
      }
      return null;
    },
    finishedLesson() {
      return (
        this.lesson && this.lesson.progress && this.lesson.progress.finished_at
      );
    },
    chapters() {
      return get(this.lesson, "chapters", []).sort((a, b) => {
        if (a.time > b.time) {
          return 1;
        }
        if (b.time > a.time) {
          return -1;
        }
        return 0;
      });
    }
  },
  mounted() {
    this.resetComments();
  },
  methods: {
    onSuccess() {
      setTimeout(() => {
        const container = document.querySelector(".scroll-desktop");
        const target = document.getElementById(
          `lesson-${this.$route.params.lesson}`
        );
        container.scrollTo({
          top: target.offsetTop,
          behavior: "smooth"
        });
      }, 100);
    },
    resetComments() {
      this.$store.commit("forum/setComments", []);
    },
    reload() {
      this.resetComments();
      this.$refs.forumDispatcher.dispatch();
    },
    loadMore() {
      this.loadingMore = true;
      this.params.offset += this.params.limit;
      this.$store
        .dispatch("forum/getAll", this.params)
        .then(data => {
          if (data.results.length < this.params.limit) {
            this.showLoadMore = false;
          }
        })
        .finally(() => {
          this.loadingMore = false;
        });
    },
    clickChapter(chapter) {
      const timeArr = chapter.time.split(":").map(str => parseInt(str));
      this.$refs["video-player"].player.currentTime =
        timeArr[0] * 60 * 60 + timeArr[1] * 60 + timeArr[2];
    },
    fileName(archive) {
      return archive.name
        ? `${archive.name} (${archive.type})`
        : archive.file.split("/").pop();
    },
    toggleFinished() {
      this.saveProgress({ finished: !this.finishedLesson, duration: 0 }, true);
    },
    saveProgress({ finished, duration }, refresh = false) {
      if (refresh) {
        this.loadingFinish = true;
      }
      this.$store
        .dispatch("courses/setProgress", {
          lesson: this.lesson.id,
          stopped_at: parseInt(duration),
          finished_at: finished
        })
        .then(() => {
          if (refresh) {
            this.$store
              .dispatch("courses/getDetails", this.$route.params.id)
              .finally(() => {
                this.loadingFinish = false;
              });
          }
        });
    },
    isVideoIframe(url) {
      if (!url) return false;
      if (url.includes("youtube")) return true;
      if (url.includes("scaleup")) return true;

      return false;
    },
    isAudio(archive) {
      if (archive.archives.length > 0) {
        if (archive.archives[0].type === "audio") return true;
        else {
          return false;
        }
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.view-lesson {
  min-height: calc(100vh - 56px);

  @media screen and (max-width: 991px) {
    flex-direction: column-reverse;
  }

  @media screen and (min-width: 992px) {
    .scroll-desktop {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      overflow-y: scroll;
    }
  }

  .course-description {
    font-size: 18px;
  }

  .lesson-description,
  .course-description {
    color: white;

    ::v-deep * {
      color: white !important;
    }
  }

  iframe {
    aspect-ratio: 16 / 9;
    width: 100%;
    border: none;
  }

  .course-card {
    .card-img-top {
      height: 0;
      padding-bottom: 55%;
      background-size: cover;
      background-position-x: center;
      background-position-y: center;
    }
  }

  button {
    i {
      font-size: 22px;
    }
  }

  .list-group {
    .list-group-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #576574;
      color: rgba(255, 255, 255, 0.9);

      &:hover {
        background: rgb(77, 91, 106);
      }
    }
  }

  hr {
    border-color: white;
  }

  .scroll {
    position: absolute;
    top: 39px;
    left: 15px;
    right: 15px;
    bottom: 0;
    overflow: scroll;
  }

  .buttons {
    .btn {
      @media screen and (max-width: 767px) {
        width: 100%;
        justify-content: center;
      }
    }
  }
}

.btn-sm {
  height: 42px;
  font-weight: 500;
  font-size: 16px;
}
</style>
